import { StateType } from '../../index';

export const dashboardAlphasDataSelector = (state: StateType) => state.getIn(['dashboard', 'alphas', 'data']);
export const dashboardAlphasIsFetchingSelector = (state: StateType) => state.getIn(['dashboard', 'alphas', 'isFetching']);
